import type { IconSvgObject } from './types';

const Pentagon01Icon: IconSvgObject = [
  ["path", { d: "M6.56154 21.7193H17.4384C18.3562 21.7193 19.1561 21.0947 19.3787 20.2044L21.6887 10.9648C21.8784 10.2061 21.6085 9.40652 20.9978 8.91799L13.2494 2.71903C12.5189 2.13467 11.481 2.13465 10.7506 2.71899L3.00218 8.91753C2.39151 9.40605 2.12159 10.2057 2.31126 10.9644L4.62125 20.2043C4.84384 21.0947 5.6438 21.7193 6.56154 21.7193Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Pentagon01Icon;
